/* === Nubbli: Google Ads Klick-ID + Consent Capture (Server-Side Conversion Upload) === */
(function(){
  var LSK='nubbli_gads';
  var CK=['gclid','gbraid','wbraid'], UK=['utm_source','utm_medium','utm_campaign','utm_term','utm_content'];
  var FIELDS=['gclid','gbraid','wbraid','utm_source','utm_medium','utm_campaign','utm_term','utm_content','gads_ts','nb_ref','nb_land','ad_consent'];
  function rd(){ try{ return JSON.parse(localStorage.getItem(LSK)||'{}'); }catch(e){ return {}; } }
  function wr(o){ try{ localStorage.setItem(LSK, JSON.stringify(o)); }catch(e){} }
  function consent(){
    try{
      var cp = window.Shopify && Shopify.customerPrivacy;
      if (cp && typeof cp.currentVisitorConsent==='function'){
        var c = cp.currentVisitorConsent() || {};
        var m = c.marketing;
        if (m==='yes'||m===true)  return 'granted';
        if (m==='no' ||m===false) return 'denied';
        return 'pending';
      }
    }catch(e){}
    return 'unknown';
  }
  function capture(){
    var p = new URLSearchParams(location.search), o = rd(), ch=false;
    CK.concat(UK).forEach(function(k){ var v=p.get(k); if(v){ o[k]=v; ch=true; } });
    if ((p.get('gclid')||p.get('gbraid')||p.get('wbraid')) && !o.gads_ts){ o.gads_ts=new Date().toISOString(); ch=true; }
    if (!o.nb_land){ o.nb_land = location.pathname.slice(0,120); ch=true; }
    if (!o.nb_ref){
      var r='direkt';
      try{ if (document.referrer){ var h=new URL(document.referrer).hostname.replace(/^www\./,''); if (h && h!==location.hostname.replace(/^www\./,'')) r=h.slice(0,80); } }catch(e){}
      o.nb_ref = r; ch=true;
    }
    if (ch) wr(o);
    return o;
  }
  function hatKampagne(o){ return !!(o.gclid||o.gbraid||o.wbraid||o.utm_source); }
  function push(erzwingen){
    var o = rd();
    if (!erzwingen && !hatKampagne(o)) return;   // ohne Kaufabsicht keinen leeren Cart anlegen
    o.ad_consent = consent();
    var a={};
    FIELDS.forEach(function(k){ if(o[k]) a[k]=o[k]; });
    var sig = JSON.stringify(a);
    if (o._sig === sig) return;                  // identisch schon gesendet
    o._sig = sig; wr(o);
    fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:a})})
      .catch(function(){ var x=rd(); delete x._sig; wr(x); });
    if (a.ad_consent==='unknown' || a.ad_consent==='pending') setTimeout(function(){ push(erzwingen); }, 4000);
  }
  capture();
  window.NubbliSyncAdAttrs = function(){ push(true); };

  // Wichtigster Ausloeser: JEDER erfolgreiche Warenkorb-Zugang, egal ueber welchen
  // Knopf. Vorher haing das an einer Selektor-Liste ('#atc', '[name=add]', …) und
  // damit daran, dass jeder Kaufweg des Themes darin vorkommt — die mobile
  // Sticky-Leiste (#stickyAtc), Quick-Add und Drawer taten das nicht zuverlaessig.
  // fetch und XHR abzufangen ist unabhaengig davon, welcher Knopf gedrueckt wurde.
  function istCart(u){ try{ return String(u).indexOf('/cart/add') > -1 || String(u).indexOf('/cart/change') > -1; }catch(e){ return false; } }
  if (window.fetch){
    var origFetch = window.fetch;
    window.fetch = function(){
      var u = arguments[0] && arguments[0].url ? arguments[0].url : arguments[0];
      var p = origFetch.apply(this, arguments);
      if (istCart(u)) { try{ p.then(function(){ setTimeout(function(){ push(true); }, 120); }).catch(function(){}); }catch(e){} }
      return p;
    };
  }
  if (window.XMLHttpRequest){
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function(m, u){
      if (istCart(u)) this.addEventListener('load', function(){ setTimeout(function(){ push(true); }, 120); });
      return origOpen.apply(this, arguments);
    };
  }

  // Sicherheitsnetz: Beim Verlassen der Seite pruefen, ob der Warenkorb gefuellt
  // ist, die Attribute aber fehlen — dann per sendBeacon nachtragen.
  function netz(){
    try{
      var o = rd();
      if (o._sig) return;                       // schon geschrieben
      fetch('/cart.js').then(function(r){ return r.json(); }).then(function(c){
        if (c && c.item_count > 0) push(true);
      }).catch(function(){});
    }catch(e){}
  }
  document.addEventListener('visibilitychange', function(){ if (document.visibilityState === 'hidden') netz(); });

  var kick=function(){ setTimeout(function(){ push(false); },500); };
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',kick); else kick();
  document.addEventListener('visitorConsentCollected', function(){ push(false); });
  // Die bisherigen Ausloeser bleiben als zusaetzliche Absicherung bestehen.
  document.addEventListener('submit', function(e){ try{ if(e.target && e.target.matches && e.target.matches('form[action*="/cart/add"]')) push(true); }catch(_){} }, true);
  document.addEventListener('click', function(e){ try{ if(e.target && e.target.closest && e.target.closest('[name="add"],#atc,#stickyAtc,[href*="/checkout"],[name="checkout"],.btn-cta')) push(true); }catch(_){} }, true);
})();

/* ============================================================
   Nubbli(TM) - interactions for Shopify theme
   (cart = self-contained slide-out drawer)
   ============================================================ */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    wireMobileNav();
    wireAccordions();
    wireReveal();
    wireCartDrawer();
    NubbliRefreshCart();
  });

  function wireMobileNav(){
    var nav = document.getElementById('mobileNav');
    var open = document.getElementById('navOpen');
    var close = document.getElementById('navClose');
    if (open && nav) open.addEventListener('click', function(){ nav.classList.add('is-open'); document.body.style.overflow='hidden'; });
    if (close && nav) close.addEventListener('click', function(){ nav.classList.remove('is-open'); document.body.style.overflow=''; });
  }

  function wireAccordions(){
    document.querySelectorAll('.acc__q').forEach(function(q){
      q.addEventListener('click', function(){
        var acc = q.closest('.acc');
        var a = acc.querySelector('.acc__a');
        var open = acc.classList.toggle('is-open');
        a.style.maxHeight = open ? a.scrollHeight + 'px' : 0;
      });
    });
  }

  function wireReveal(){
    var els = document.querySelectorAll('.reveal');
    if (!els.length) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)){ els.forEach(function(e){ e.classList.add('in'); }); return; }
    document.documentElement.classList.add('reveal-on');
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if (en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { threshold: .08, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function(e){ io.observe(e); });
    setTimeout(function(){ document.documentElement.classList.remove('reveal-on'); }, 4000);
  }

  /* ---- Toast (kept available, not used by add-to-cart) ---- */
  var toastT;
  window.NubbliToast = function(msg){
    var t = document.getElementById('toast'); if (!t) return;
    document.getElementById('toastMsg').textContent = msg;
    t.classList.add('is-show'); clearTimeout(toastT);
    toastT = setTimeout(function(){ t.classList.remove('is-show'); }, 3200);
  };

  /* ---- Shopify cart count ---- */
  window.NubbliRefreshCart = function(){
    fetch('/cart.js', { headers: { 'Accept':'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(c){
        document.querySelectorAll('[data-cart-count]').forEach(function(b){
          b.textContent = c.item_count;
          if (c.item_count > 0) b.removeAttribute('hidden'); else b.setAttribute('hidden','');
        });
      }).catch(function(){});
  };

  /* ---- Cart drawer ---- */
  function escHtml(v){ return String(v==null?'':v).replace(/[&<>"]/g, function(c){ return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'})[c]; }); }
  function eur(cents){ return (Number(cents||0)/100).toFixed(2).replace('.', ',') + ' €'; }

  function ncartRender(cart){
    var body = document.getElementById('ncartBody'); if (!body) return;
    var sub = document.getElementById('ncartSubtotal');
    if (!cart || !cart.items || !cart.items.length){
      body.innerHTML = '<p class="ncart__empty">Dein Warenkorb ist noch leer.</p>';
      if (sub) sub.textContent = '';
      return;
    }
    var rows = cart.items.map(function(it){
      var img = it.image || (it.featured_image && it.featured_image.url) || '';
      var imgT = img ? (img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=160') : '';
      var variant = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
      var price = eur(it.final_line_price != null ? it.final_line_price : it.line_price);
      var key = escHtml(it.key);
      return '<div class="ncart__row">'
        + (imgT ? '<img src="' + imgT + '" alt="" width="72" height="72" loading="lazy">' : '')
        + '<div class="ncart__info">'
        +   '<div class="ncart__name">' + escHtml(it.product_title || it.title) + '</div>'
        +   (variant ? '<div class="ncart__variant">' + escHtml(variant) + '</div>' : '')
        +   '<div class="ncart__stepper" role="group" aria-label="Menge ändern">'
        +     '<button type="button" class="ncart__step" data-ncart-dec data-key="' + key + '" aria-label="Menge verringern">\u2013</button>'
        +     '<span class="ncart__qval" aria-live="polite">' + it.quantity + '</span>'
        +     '<button type="button" class="ncart__step" data-ncart-inc data-key="' + key + '" aria-label="Menge erhöhen">+</button>'
        +   '</div>'
        + '</div>'
        + '<div class="ncart__end">'
        +   '<button type="button" class="ncart__remove" data-ncart-remove data-key="' + key + '" aria-label="Artikel entfernen">Entfernen</button>'
        +   '<div class="ncart__price">' + price + '</div>'
        + '</div>'
        + '</div>';
    }).join('');
    body.innerHTML = rows;
    if (sub) sub.textContent = eur(cart.total_price);
  }

  function ncartChange(key, qty){
    fetch('/cart/change.js', {
      method:'POST',
      headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function(r){ return r.json(); })
    .then(function(cart){ ncartRender(cart); if (window.NubbliRefreshCart) NubbliRefreshCart(); })
    .catch(function(){ window.location.href = '/cart'; });
  }

  function ncartOpen(){
    var el = document.getElementById('nubbliCart'); if (!el) return;
    el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function ncartClose(){
    var el = document.getElementById('nubbliCart'); if (!el) return;
    el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  window.NubbliCartOpen = ncartOpen;
  window.NubbliCartClose = ncartClose;

  function ncartFetchAndOpen(){
    return fetch('/cart.js', { headers:{ 'Accept':'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(c){ ncartRender(c); ncartOpen(); });
  }

  function wireCartDrawer(){
    document.querySelectorAll('[data-ncart-close]').forEach(function(b){
      b.addEventListener('click', ncartClose);
    });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape') ncartClose(); });
    var headerCart = document.querySelector('a[aria-label^="Warenkorb"]');
    if (headerCart){
      headerCart.addEventListener('click', function(e){ e.preventDefault(); ncartFetchAndOpen(); });
    }
    var cbody = document.getElementById('ncartBody');
    if (cbody){
      cbody.addEventListener('click', function(e){
        var btn = e.target.closest('[data-key]'); if (!btn) return;
        var key = btn.getAttribute('data-key');
        var row = btn.closest('.ncart__row');
        var qEl = row && row.querySelector('.ncart__qval');
        var q = qEl ? (parseInt(qEl.textContent, 10) || 1) : 1;
        btn.disabled = true;
        if (btn.hasAttribute('data-ncart-remove')) ncartChange(key, 0);
        else if (btn.hasAttribute('data-ncart-dec')) ncartChange(key, Math.max(0, q - 1));
        else if (btn.hasAttribute('data-ncart-inc')) ncartChange(key, q + 1);
      });
    }
  }

  /* ---- Ajax add to cart (used by product form) -> opens drawer ---- */
  window.NubbliAddToCart = function(form){
    var data = new FormData(form);
    return fetch('/cart/add.js', { method:'POST', headers:{ 'Accept':'application/json' }, body:data })
      .then(function(r){ if (!r.ok){ throw new Error('add failed'); } return r.json(); })
      .then(function(){ NubbliRefreshCart(); return ncartFetchAndOpen(); })
      .catch(function(){ window.location.href = '/cart'; });
  };
})();
